import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAutocomplete,{staticClass:"select",attrs:{"hide-details":_vm.hideDetails,"items":_vm.knownProjectSelectables,"value":_vm.value,"loading":_vm.loading || _vm.internalLoading,"disabled":_vm.disabled || _vm.internalLoading,"item-text":"name","return-object":"","overflow":"","label":"Projekt"},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }